import axios, { AxiosInstance } from 'axios'

const http: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_MRP_ENDPOINT,
  timeout: 99999999,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

// http.interceptors.response.use(
//   res => {
//     return res
//   },
//   async err => {
//     if (err.response.status === 500) {
//       toast({
//         title: 'Error!',
//         description: 'Ocorreu um erro interno',
//         status: 'error',
//         duration: 5000,
//         isClosable: true,
//         position: 'bottom-right'
//       })
//       return
//     }
//     return Promise.reject(err)
//   }
// )
// http.interceptors.request.use(req => {
//   const userInfos = JSON.parse(
//     localStorage.getItem(
//       '@@auth0spajs@@::U72wVWZLzQKIY4Rlsnlj1xY8sn9TeIth::https://api-scl4-core-dev/::openid profile email offline_access'
//     )
//   )

//   // const token = Cookies.get('SCLToken')
//   //   ? `Bearer ${Cookies.get('SCLToken')}`
//   //   : 'Bearer'
//   // if (Cookies.get('SCLToken')) {
//   //   req.headers = {
//   //     Authorization: token
//   //   }
//   // }

//   // const accessToken = JSON.parse(localStorage.getItem('@access_token_rl'))

//   if (userInfos) {
//     req.headers.Authorization = `Bearer ${
//       userInfos ? userInfos.body?.access_token : ''
//     }`
//   }
//   return req
// })

// let isRefreshing = false
// http.interceptors.response.use(
//   response => {
//     return response
//   },
//   error => {
//     const {
//       config,
//       response: { status }
//     } = error
//     const originalRequest = config

//     if (status === 401) {
//       const tokenSSO = localStorage.getItem('userSSO')

//       if (!isRefreshing) {
//         isRefreshing = true
//         const token = Cookies.get('SCLToken')
//         const refreshToken = Cookies.get('SCLRefreshToken')
//         let isExpired = false
//         const decodedToken: any = decodeToken(token)
//         const dateNow = new Date()
//         const time = dateNow.getTime() / 1000

//         if (decodedToken.exp + 60 < time) {
//           isExpired = true
//         }
//         isRefreshing = true
//         if (!isExpired) {
//           if (decodedToken.exp < time) {
//             httpOrigin
//               .post('v1/Auth/RefreshToken', {
//                 token,
//                 refreshToken
//               })
//               .then((data: any) => {
//                 isRefreshing = false
//                 Cookies.set('SCLToken', data.data.data.token)
//                 Cookies.set('SCLRefreshToken', data.data.data.refreshToken)
//                 onRrefreshed(data.data.data.token)
//               })
//           } else {
//             isRefreshing = false
//           }
//         } else {
//           httpOrigin
//             .post('v1/Auth/Login', { token: `${tokenSSO}` })
//             .then((data: any) => {
//               isRefreshing = false
//               Cookies.set('SCLToken', data.data.data.token)
//               Cookies.set('SCLRefreshToken', data.data.data.refreshToken)
//               onRrefreshed(data.data.data.token)
//             })
//         }
//       }

//       const retryOrigReq = new Promise(resolve => {
//         subscribeTokenRefresh((token: any) => {
//           originalRequest.headers.Authorization = 'Bearer ' + token
//           resolve(axios(originalRequest))
//         })
//       })
//       return retryOrigReq
//     } else {
//       return Promise.reject(error)
//     }
//   }
// )

// function subscribeTokenRefresh(cb: any) {
//   refreshSubscribers.push(cb)
// }
// const isRefreshingProfile = false
// http.interceptors.response.use(
//   response => {
//     return response
//   },
//   error => {
//     const {
//       config,
//       response: { status }
//     } = error
//     const originalRequest = config

//     // if (status === 406) {
//     //   const tokenSSO = localStorage.getItem('userSSO')

//     //   if (!isRefreshingProfile) {
//     //     isRefreshingProfile = true
//     //     isRefreshingProfile = true
//     //     httpOrigin
//     //       .post('v1/Auth/Login', { token: `${tokenSSO}` })
//     //       .then((data: any) => {
//     //         isRefreshing = false
//     //         Cookies.set('SCLToken', data.data.data.token)
//     //         Cookies.set('SCLRefreshToken', data.data.data.refreshToken)
//     //         onRrefreshed(data.data.data.token)
//     //         window.location.reload()
//     //       })
//     //   }

//     //   const retryOrigReq = new Promise(resolve => {
//     //     subscribeTokenRefresh((token: any) => {
//     //       originalRequest.headers.Authorization = 'Bearer ' + token
//     //       resolve(axios(originalRequest))
//     //     })
//     //   })
//     //   return retryOrigReq
//     // } else {
//     //   return Promise.reject(error)
//     // }
//   }
// )

export default http
